import { render, staticRenderFns } from "./RecruitingDetailDialog.vue?vue&type=template&id=bba09cb6&scoped=true&lang=pug&"
import script from "./RecruitingDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./RecruitingDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RecruitingDetailDialog.vue?vue&type=style&index=0&id=bba09cb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba09cb6",
  null
  
)

export default component.exports